import { render, staticRenderFns } from "./editClassCtr.vue?vue&type=template&id=c5b47d20&scoped=true"
import script from "./editClassCtr.vue?vue&type=script&lang=js"
export * from "./editClassCtr.vue?vue&type=script&lang=js"
import style0 from "./editClassCtr.vue?vue&type=style&index=0&id=c5b47d20&prod&lang=less"
import style1 from "./editClassCtr.vue?vue&type=style&index=1&id=c5b47d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b47d20",
  null
  
)

export default component.exports